import { useAtom, useAtomValue } from 'jotai/index';
import {
  crashedTimeState,
  gameStatusState,
  noBetState,
  noNextRoundBetState,
} from '@/components/features/casino/crash/state';
import { useMemo } from 'react';
import { GameStatus } from '@/components/features/casino/crash/types/crash';

export const useDisableInput = () => {
  const gameStatus = useAtomValue(gameStatusState);
  const hasBet = !useAtomValue(noBetState);
  const hasNextRoundBet = !useAtomValue(noNextRoundBetState);
  const [crashedTime] = useAtom(crashedTimeState);

  const disabled = useMemo(() => {
    if (gameStatus === GameStatus.Starting && hasBet) {
      return true;
    }
    if (gameStatus === GameStatus.InProgress && hasBet && !crashedTime) {
      return true;
    }
    return hasNextRoundBet;
  }, [gameStatus, hasBet, hasNextRoundBet, crashedTime]);

  return disabled;
};

export default useDisableInput;
